export default "__VITE_ASSET__DKGYQb71__"